export const getVar = cssVar => {
  var _cssVar;
  if (!((_cssVar = cssVar) !== null && _cssVar !== void 0 && _cssVar.startsWith('var('))) return cssVar;
  cssVar = cssVar.replace(/^var\(|\)$/g, '');
  const rootStyles = getComputedStyle(document.documentElement);
  return rootStyles.getPropertyValue(cssVar).trim();
};
export const alphaColor = (hex, a) => {
  if (hex.startsWith('var(')) hex = getVar(hex);

  // Expand shorthand (e.g., #fff to #ffffff)
  if (/^#([a-f\d]{3})$/i.test(hex)) {
    hex = hex.replace(/^#([a-f\d])([a-f\d])([a-f\d])$/i, (_, r, g, b) => `#${r}${r}${g}${g}${b}${b}`);
  }
  const rgb = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return rgb ? `rgba(${parseInt(rgb[1], 16)}, ${parseInt(rgb[2], 16)}, ${parseInt(rgb[3], 16)}, ${a})` : '';
};
const hexToRgb = hex => {
  if (hex.startsWith('var(')) hex = getVar(hex);
  hex = hex.replace(/^#/, '');
  let r = parseInt(hex.substring(0, 2), 16);
  let g = parseInt(hex.substring(2, 4), 16);
  let b = parseInt(hex.substring(4, 6), 16);
  return {
    r,
    g,
    b
  };
};
function parseRgb(color) {
  const rgbaRegex = /^rgba?\(\s*([0-9]+),\s*([0-9]+),\s*([0-9]+)(?:,\s*([0-9]*\.?[0-9]+))?\s*\)$/;
  const match = color.match(rgbaRegex);
  if (match) {
    const r = parseInt(match[1], 10);
    const g = parseInt(match[2], 10);
    const b = parseInt(match[3], 10);
    const a = match[4] !== undefined ? parseFloat(match[4]) : 1;
    return {
      r,
      g,
      b,
      a
    };
  } else {
    throw new Error('Invalid RGB or RGBA color string');
  }
}
export const brightenColor = _ref => {
  let {
    color,
    bright: percent = 0,
    alpha
  } = _ref;
  let r, g, b, a;
  a;
  if (color.startsWith('var(')) color = getVar(color);
  if (color.startsWith('#')) {
    ({
      r,
      g,
      b
    } = hexToRgb(color));
    a = 1;
  } else if (color.startsWith('rgb')) {
    ({
      r,
      g,
      b,
      a
    } = parseRgb(color));
  } else {
    throw new Error('Unsupported color format');
  }

  // Brighten each component by the specified percentage
  r = Math.min(255, Math.floor(r + (255 - r) * (percent / 100)));
  g = Math.min(255, Math.floor(g + (255 - g) * (percent / 100)));
  b = Math.min(255, Math.floor(b + (255 - b) * (percent / 100)));
  return `rgba(${r}, ${g}, ${b}, ${alpha || a})`;
};
export const getRandomHexadecimalColor = previousColors => {
  const letters = '0123456789ABCDEF';
  let color = '#';
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  if (previousColors !== null && previousColors !== void 0 && previousColors.length && previousColors.includes[color]) {
    return getRandomHexadecimalColor(previousColors);
  }
  return color;
};